import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
    Outlet,
    useLocation,
    useNavigate,
    useSearchParams,
} from "react-router-dom";
import { COOKIE_INFO, COOKIE_SESS } from "../config";
import { getAutoToken, registerConnection } from "../requests/auth";
import { saveSession, setChatInfo } from "../store";

export default function Root() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const session = useSelector((state) => state.session.value);
    const [cookie, setCookie, removeCookie] = useCookies([
        COOKIE_SESS,
        COOKIE_INFO,
    ]);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            if (searchParams.get("agent")) {
                const user = searchParams.get("agent");

                const r = await getAutoToken({ user });

                if (r.status === "ok") {
                    const { token, name, user, role } = r.result;
                    setCookie(
                        COOKIE_SESS,
                        { token, name, user, role },
                        {
                            path: "/",
                            sameSite: "none",
                            secure: true,
                        }
                    );
                    dispatch(saveSession({ token, name, user, role }));
                    navigate("/home/", {
                        replace: true,
                    });
                }
            }

            if (session) {
                if (pathname === "/" || pathname === "/login") {
                    navigate("/home/", {
                        replace: true,
                    });
                }
            } else {
                if (
                    cookie[COOKIE_SESS] !== undefined &&
                    cookie[COOKIE_SESS] !== null
                ) {
                    const { token, name, user, role } = cookie[COOKIE_SESS];
                    const r = await registerConnection({ token });
                    if (r.status === "ok") {
                        if (
                            cookie[COOKIE_INFO] !== undefined &&
                            cookie[COOKIE_INFO] !== null
                        ) {
                            dispatch(setChatInfo(cookie[COOKIE_INFO]));
                        }
                        dispatch(saveSession({ token, name, user, role }));
                    } else {
                        removeCookie(COOKIE_SESS, {
                            path: "/",
                            sameSite: "none",
                            secure: true,
                        });
                        if (pathname.indexOf("/login") === -1) {
                            navigate("/login");
                        }
                    }
                } else {
                    if (pathname.indexOf("login") === -1) {
                        navigate("/login");
                    }
                }
            }
        })();
    }, [session]);

    return <Outlet />;
}
